import { useMemo } from 'react';
import _ from 'underscore';

import { LogUtils } from '@bingads-webui-clientcenter/common-utils';

import { defaultLogger } from './shape';

const { logPageLoadAndNavigationDuration } = LogUtils;

export const getLogger = (loggerParams) => {
  const { defaultScenarioName, logging } = _.defaults({}, loggerParams, {
    defaultScenarioName: '',
    logging: {},
  });
  if (logging === null) {
    return defaultLogger;
  }

  const getScenarioName = scenarioName => scenarioName || defaultScenarioName;
  const stringifyMessage = message => (_.isString(message) ? message : JSON.stringify(message));

  const logger = {
    trace: ({ scenarioName, message } = {}) => _.isFunction(logging.trace) && logging.trace(getScenarioName(scenarioName), stringifyMessage(message)),
    error: ({ scenarioName, message } = {}) => _.isFunction(logging.error) && logging.error(getScenarioName(scenarioName), stringifyMessage(message)),
    startScenario: ({ scenarioName, message } = {}) => _.isFunction(logging.startScenario) && logging.startScenario(getScenarioName(scenarioName), message),
    endScenario: ({ scenarioName, result, message } = {}) => _.isFunction(logging.endScenario) && logging.endScenario(getScenarioName(scenarioName), result, message),
    logPageLoadAndNavigationDuration: ({ pageReadyMark } = {}) => logPageLoadAndNavigationDuration({ logging, pageReadyMark }),
  };

  return logger;
};

export const useLogger = ({
  defaultScenarioName = '',
  logging,
} = {}) => useMemo(() => getLogger({ defaultScenarioName, logging }), [defaultScenarioName, logging]);
